import React, { PropTypes, PureComponent } from 'react';
import jack from 'jack-logs';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import { Button, Input, Dropdown, Textarea, Modal } from '../../../../shared';

import './styles.scss';

export class Leave extends PureComponent {
  constructor(props) {
    super(props);

    // functions
    this.updateField = this.updateField.bind(this);

    // props
    this.state = {
      options: [],
      hours: this.props.settings.leave_request_default_length,
      modal: null,
    };
  }

  async componentDidMount() {
    try {
      const types = await this.props.prepareLeavePage(this.props.currentUser.id);
      const options = [];
      Object.keys(types).forEach((key) => {
        const name = key + (types[key] ? ` - ${types[key]} hrs` : '');

        options.push({ name, value: key });
      });
      /*
       From https://github.com/yannickcr/eslint-plugin-react/blob/master/docs/rules/no-did-mount-set-state.md
       Will cause a re-render, but we don't really have much choice.  The official React docs say to
       use thismethod for AJAX calls.
       Maybe we need to move the optionsto the props.currentUser, but that will also trigger a
       re-render
       */
      this.setState({ options });
    } catch (e) {
      this.setState({
        modal: <Modal
          icontype="fa fa-exclamation-circle fa-4x"
          title="No Internet Connection"
          message="Sorry, you can't submit leave requests without internet."
          onClick={this.props.backwardActivity}
        />,
      });
    }
  }

  getModal() {
    if (this.state.modal) {
      return this.state.modal;
    }
    return null;
  }

  getHours() {
    if (this.state.hours) {
      return this.state.hours.toString();
    }
    return '';
  }

  async submitForm(event) {
    event.preventDefault(); // stop the form from submitting.
    try {
      const res = await this.props.submitLeaveRequest({
        ...this.state,
        user_id: this.props.currentUser.id,
        hours: parseFloat(this.state.hours),
      });
      if (res !== false) {
        this.props.showConfirm();
      }
    } catch (e) {
      jack.error(e);
    }
  }

  updateField(field, value) {
    this.props.parentInteract();
    this.setState({
      [field]: value,
    });
  }

  render() {
    return (
      <form className='leave' onSubmit={event => this.submitForm(event)}>
        {this.getModal()}
        <div className="leave-row">
          <div className='leave-field'><h3>START</h3></div>
          <div className='leave-field'><h3>END</h3></div>
        </div>

        <div className='leave-row'>
          <Input
            name='Date:'
            type='date'
            className='leave-field'
            onChange={event => this.updateField('start', event.target.value)}
          />
          <Input
            name='Date:'
            type='date'
            className='leave-field'
            onChange={event => this.updateField('finish', event.target.value)}
          />
        </div>

        <div className='leave-row padded'>
          <Dropdown
            name='Type of Leave:'
            className='leave-dropdown'
            options={this.state.options}
            placeholder="Please select a type"
            onChange={event => this.updateField('leave_type', event.target.value)}
          />
          <Input
            name='Hours:'
            type='number'
            className='leave-field hours'
            value={this.getHours()}
            placeholder="eg. 7.6"
            onChange={event => this.updateField('hours', event.target.value)}
          />
        </div>

        <Textarea
          name='Reason:'
          className='leave-text'
          rows='3'
          onChange={event => this.updateField('reason', event.target.value)}
          placeholder="eg. Holiday to Legoland"
        />

        <div className='leave-controls'>
          <ReactCSSTransitionGroup
            component='div'
            transitionName='fade'
            transitionAppear={false}
            transitionEnterTimeout={500}
            transitionLeaveTimeout={500}
          >

            {this.props.showNotification()}
          </ReactCSSTransitionGroup>

          <Button className='blue' type='submit'>
            <p>Submit Leave Request</p>
          </Button>
        </div>

      </form>
    );
  }
}

Leave.propTypes = {
  currentUser: PropTypes.object,
  submitLeaveRequest: PropTypes.func,
  prepareLeavePage: PropTypes.func,
  showNotification: PropTypes.func,
  showConfirm: PropTypes.func,
  settings: PropTypes.object,
  backwardActivity: PropTypes.func,
  parentInteract: PropTypes.func,
};


export default Leave;



// WEBPACK FOOTER //
// ./src/components/timeclock/userhub/requests/leave/main.jsx